import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Layers, Info, Mail } from 'lucide-react';
import logo from '../pages/assets/logo2.png';

const Navbar = () => {
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/home', icon: <Home size={22} /> },
    { name: 'Services', path: '/services', icon: <Layers size={22} /> },
    { name: 'About', path: '/about', icon: <Info size={22} /> },
    { name: 'Contact', path: '/contact', icon: <Mail size={22} /> }
  ];

  return (
    <>
      {/* Top Navbar (Desktop & Mobile Header) */}
      <nav className="fixed top-0 left-0 w-full z-50 bg-white/90 backdrop-blur-lg border-b border-gray-100 shadow-sm transition-all duration-300">
        <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-6 md:px-8 min-h-[64px]">

          <Link to="/" className="flex items-center">
            <img src={logo} alt="Cloud Services Technology Ltd" className="h-10 md:h-12 w-auto object-contain mix-blend-multiply transform scale-150 origin-left" />
          </Link>

          <div className="flex items-center space-x-4 md:space-x-8">
            {/* Desktop Nav */}
            <div className="hidden md:flex space-x-8 text-gray-600 font-medium items-center">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`hover:text-gray-900 transition-colors ${location.pathname === link.path ? 'text-brand-primary font-bold' : ''}`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Always Visible Enquire Button */}
            <div className="flex items-center md:pl-5 md:border-l md:border-gray-200">
              <Link to="/contact" className="bg-brand-primary hover:bg-brand-dark transition-colors text-white px-5 py-2 md:px-6 md:py-2.5 rounded-full font-medium text-xs md:text-sm shadow-md hover:shadow-lg transform hover:-translate-y-0.5 duration-200 min-h-[40px] md:min-h-[48px] flex items-center justify-center">
                Enquire Now
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Bottom Navigation Bar */}
      <nav className="md:hidden fixed bottom-0 left-0 w-full z-50 bg-white/90 backdrop-blur-lg border-t border-gray-200 shadow-[0_-10px_40px_rgba(0,0,0,0.08)] pb-safe">
        <div className="flex justify-around items-center h-16 px-2">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.name}
                to={link.path}
                className={`flex flex-col items-center justify-center w-full h-full space-y-1 relative ${isActive ? 'text-brand-primary' : 'text-gray-400 hover:text-gray-600'}`}
              >
                {isActive && (
                  <span className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-brand-primary rounded-b-full"></span>
                )}
                <div className={`mt-1 ${isActive ? 'scale-110 transition-transform' : ''}`}>
                  {link.icon}
                </div>
                <span className={`text-[10px] font-medium tracking-wide ${isActive ? 'font-bold' : ''}`}>{link.name}</span>
              </Link>
            );
          })}
        </div>
      </nav>

      {/* Spacers */}
      <div className="h-[64px]"></div>
    </>
  );
};

export default Navbar;
